import { render, staticRenderFns } from "./SignatureManuscript.vue?vue&type=template&id=e5619b58&scoped=true"
import script from "./SignatureManuscript.vue?vue&type=script&lang=js"
export * from "./SignatureManuscript.vue?vue&type=script&lang=js"
import style0 from "./SignatureManuscript.vue?vue&type=style&index=0&id=e5619b58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5619b58",
  null
  
)

export default component.exports